/* src/app/ai-sourcing/ai-sourcing-activity/ai-sourcing-activity.component.scss */
.activity-group {
  margin-bottom: 24px;
}
.activity-date {
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 12px;
  color: #333;
}
.activity-entry {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.activity-icon {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #cbd5e0;
  text-align: center;
  line-height: 32px;
  font-weight: bold;
  color: #2d3748;
  margin-right: 12px;
  font-size: 14px;
}
.activity-details {
  flex: 1;
  font-size: 14px;
  color: #444;
}
.activity-name {
  font-weight: 500;
  margin-right: 4px;
}
.activity-action {
  color: #555;
}
.img-config-review {
  width: 170px;
  height: 130px;
}
/*# sourceMappingURL=ai-sourcing-activity.component-O6XQ7SGO.css.map */
